
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "../lib/Bus"; const bus: Bus = new Bus().getBus(); 
import { Finder, IFinder } from "./IFinder"
import { Debouncer } from "@/lib/Debouncer"

@Component
export default class FinderVue extends Vue {

  @Prop(String) url!:string;
  @Prop(Array) data!:any[];
  @Prop(Object) finder!:IFinder;
  @Prop(String) selected_event!:string;
  @Prop(String) placeholder!:string;
  @Prop(Boolean) select_only_one!:boolean;
  debounced:any;

  filter: string =''
  api_loaded: boolean = false
  objs:any[]=[];
  obj: any = {}
  filter_locally:boolean=false
  filter_arr_upper:string[]=[]
  key:number=0;
  aborted:number=0;

  created() {
    //console.log("finder created", this.finder)
  }

  async mounted () {
  //  console.log("finder mounted", this.finder)
    if (this.url) {
      this.debounced = Debouncer.debounce(await (this._getList.bind(this)), 1000).bind(this);
    } else {
      this.debounced = Debouncer.debounce(await (this._getList.bind(this)), 10).bind(this);
    }
//    console.log(this.finder)
//    console.log(this.finder._id)
    if (this.finder && this.finder._id) {
      this.selectItem(this.finder, true)
    } else if (this.select_only_one && this.data.length==1) {
        const theItem=this.data[0]
        this.obj = theItem 
        this.finder.data = this.create_data(this.obj)
        bus.fire(this.selected_event, this.finder);
    }
    else {
      await this.resetSelectionQuietly()
    }
  }

  abort_list() {
    this.resetSelectionFire()
    this.aborted=1;
    this.key++
  }

  resetSelectionFire () {
    this.resetSelectionQuietly()    
    bus.fire(this.selected_event, this.finder);
  }

  resetSelectionQuietly () {
    this.obj = {}
    if (this.$refs.finderinput) {
      this.$nextTick( () => (<any>this.$refs.finderinput)?.focus() )
    }
    this.$emit('on-item-reset')
    this.finder._id="";
    this.finder.text="";
    this.finder.data={}
    
  }

  create_data(obj:any) {
    const data:any={}
    for (let key in obj) {
      if (key.indexOf('data_')==0) {
        data[key]=obj[key]
      }
    }
    console.log("Finder create data",JSON.stringify(data))
    return data;
  }

  selectItem (theItem:any, quiet?:boolean) {
    //console.log("selectItem", theItem)
    //console.log("selectItem:obj", JSON.stringify(this.obj))
    //console.log("selectItem:this.finder.data", JSON.stringify(this.finder.data))

    this.obj = theItem 
    this.finder.filter = ''
    this.finder._id=theItem._id;
    this.finder.text=theItem.text;
    if (!quiet)
    {
      this.finder.data = this.create_data(this.obj)
    }
    //console.log("selectItem:this.finder.data2", JSON.stringify(this.finder.data))
    console.log("Finder",JSON.stringify(this.finder))
    //this.$emit(this.selected_event, theItem)
    if (!quiet) {
      console.log("finder: fire:",this.selected_event)
      bus.fire(this.selected_event, this.finder);
    }
    
  }

  contains(text_upper: string):boolean { 
        let ok=true
        for (let i=0;i<this.filter_arr_upper.length;i++) {
          if (this.filter_arr_upper[i]) {
              if (text_upper.indexOf(this.filter_arr_upper[i])==-1) ok=false
          }
        }
        return ok
  }

  async _getList () {
    this.aborted=0;
    console.log("getlist")

    if (!this.data) {
      this.obj={};
      this.objs = await bus.call(this.url, {filter: this.finder.filter, id:this.finder._id})
      if (!this.objs) this.objs=[]
    } else {
      this.filter_arr_upper = this.finder.filter.toLocaleUpperCase().split('+');
      this.objs = this.data.filter((obj:any) =>  this.contains(obj.text) );
    }
    this.api_loaded = true
  }

  async getListQuick() {
    if (!this.url) this.getList()
  }
  
  async getList () {
    if (!this.finder) return;
    if (!this.debounced) return;

    await this.debounced();
    const refs:any=(<any>this).$refs
    //refs['lista'].$el.scrollIntoView({ behavior: 'smooth',block: "top" });
  }

}
